import { createSignal, onCleanup } from 'solid-js';

const QUERY = '(max-width: 1023px)';

export function useIsMobileWidth() {
  const [isMobile, setIsMobile] = createSignal(typeof window !== 'undefined' && window.matchMedia(QUERY).matches);

  if (typeof window !== 'undefined') {
    const mql = window.matchMedia(QUERY);
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    mql.addEventListener('change', handler);
    onCleanup(() => mql.removeEventListener('change', handler));
  }

  return isMobile;
}
